export default __webpack_public_path__ + "static/media/pingouinmaison.42779aa8.png";